import BreakpointsContainer from '~/components/BreakpointsContainer';

import type { Publication, WebThemeV2 } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';

import LogoHome from '../Nav/LogoHome';
import Menu from '../Nav/Menu';
import MenuActions from '../Nav/MenuActions';

interface Props {
  publication: Publication;
  isLoggedIn?: boolean;
  subscription?: Subscription;
  isAdminLoggedIn?: boolean;
  showActions: boolean;
  theme: WebThemeV2;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const Template2 = ({ publication, isLoggedIn, subscription, isAdminLoggedIn, showActions, theme }: Props) => {
  return (
    <BreakpointsContainer
      as="nav"
      className="w-full py-2"
      style={{
        backgroundColor: theme.navbar_background_color,
      }}
    >
      <div className="mx-auto flex items-center justify-between">
        <LogoHome
          url={publication.logo.thumb.url}
          name={publication.name}
          textColor={theme.navbar_text_color}
          fontFamily={theme.navbar_font_family}
        />
        <Menu publication={publication} theme={theme} />
        <MenuActions ctaText={publication.cta_text} showActions={showActions} publication={publication} />
      </div>
    </BreakpointsContainer>
  );
};

export default Template2;
